/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 * CONFIDENTIAL & PROPRIETARY
 */

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProfileDetails, recentReview } from "../../../auth/core/_requests";
import { useAuth } from "../../../auth/core/Auth";

const CDN_BASE_URL = process.env.REACT_APP_CDN_BASE_URL || "";

interface Dish {
  name: string;
  title: string;
  description: string;
  averageReviews: string;
  user: {
    userName: string;
    profileImage: string;
  };
}

const RecentRating = () => {
  const [data, setData] = useState<Dish[]>([]);
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const chefId = currentUser?.uuid;
  const [getIsChefRating, setDishReview] = useState<any>();
const [imageError, setImageError] = useState(false);
  const getValidImageUrl = (url: string | null | undefined) => {
    if (!url || url.trim() === "") return null;

    let cleanUrl = url.replace(
      `${CDN_BASE_URL}https://`,
      "https://"
    );

    const lower = cleanUrl.toLowerCase();

    if (lower.includes("lh3.googleusercontent.com")) {
      return lower.startsWith("http") ? cleanUrl : `https://${cleanUrl}`;
    }

    if (lower.startsWith("http://") || lower.startsWith("https://")) {
      return cleanUrl;
    }

    return `${CDN_BASE_URL}${cleanUrl}`;
  };

  const getAvatarColor = (name: string | undefined) => {
    if (!name) return "#2E7D32";
    const colors = ["#2E7D32", "#1B5E20", "#43A047", "#4CAF50", "#66BB6A"];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

 useEffect(() => {
  ProfileDetails(chefId).then((res) => {
    const access =
      res.data?.chef_plan_subscriptions?.[0]?.plan?.chef_plan_accesses?.[0];

    if (access) {
      const hasRatingAccess =
        access.is_dish_ratings === true || access.is_chef_ratings === true;
      setDishReview(hasRatingAccess);
    }
  });
}, [chefId]);


const viewReviews = () =>
  getIsChefRating ? navigate("/chef-review/list") : navigate("/access");



  useEffect(() => {
    recentReview(chefId)
      .then((res: any) => setData(res))
      .catch(() => {});
  }, [chefId]);

  return (
    <div className="snippet-block btm-same-height">
      <div className="head d-flex justify-content-between align-items-center">
        <h6 className="mb-0 fw-bold">Recent Ratings</h6>
        <span className="text-link" onClick={viewReviews} style={{ cursor: "pointer" }}>
          View All
          <i className="material-symbols-outlined fall">arrow_forward</i>
        </span>
      </div>

      {data.length > 0 ? (
        data.map((item, i) => {
          
          const imgUrl = getValidImageUrl(item?.user?.profileImage);
          const initial = item?.user?.userName?.charAt(0).toUpperCase() || "U";

          return (
            <div className="snippet-content" key={i}>
              <div className="dish-card mb-3">
                <div
                  className="dish"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <div style={{ width: 45, height: 45 }}>
                    {!imageError && imgUrl ? (
                      <img
                        src={imgUrl}
                        alt={item.user.userName}
                        style={{
                          width: "45px",
                          height: "45px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                        onError={() => setImageError(true)}
                      />
                    ) : (
                      <div
                        style={{
                          width: "45px",
                          height: "45px",
                          borderRadius: "50%",
                          backgroundColor: getAvatarColor(item?.user?.userName),
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontWeight: "700",
                          fontSize: "18px",
                          color: "#fff",
                          textTransform: "uppercase",
                        }}
                      >
                        {initial}
                      </div>
                    )}
                  </div>

                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <span>{item?.user?.userName}</span>
                      <img
                        src="/assets/images/star.svg"
                        alt="Star"
                        style={{ width: "18px" }}
                      />
                      <span>
                        {item?.averageReviews
                          ? Number(item.averageReviews).toFixed(1)
                          : 0}
                      </span>
                    </div>
                    <span style={{ fontSize: "13px", color: "#505050" }}>
                      {item?.description}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="text-center mt-4">
          <img src="/assets/images/noDishes.svg" style={{ height: "50px" }} />
          <div>No Recent Ratings</div>
        </div>
      )}
    </div>
  );
};

export { RecentRating };
